<template>
	<Card>
		<div class="sales_presentation container">
			<div style="margin: 10px 0">
				<Icon type="ios-clipboard" color="blue" style="margin-right: 5px" />信息
			</div>
			<div>
				<Row :gutter="10">
					<Col :xs="{ span: 12 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="margin-bottom: 10px"
						class="sales_presentation_item">
					<div class="info" @click="showBalance">
						<span>账户余额</span>
						<span style="font-size:22px">{{balance}}</span>
					</div>
					</Col>
					<Col :xs="{ span: 12 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="margin-bottom: 10px"
						class="sales_presentation_item">
					<div class="info" @click="showRecharge">
						<span>本月充值</span>
						<span style="font-size:22px">{{recharge}}</span>
					</div>
					</Col>
					<Col :xs="{ span: 12 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="margin-bottom: 10px"
						class="sales_presentation_item">
					<div class="info" @click="showCostList">
						<span>本月消耗</span>
						<span style="font-size:22px">{{consume}}</span>
					</div>
					</Col>
					<Col :xs="{ span: 12 }" :md="{ span: 6 }" :lg="{ span: 6 }" style="margin-bottom: 10px"
						class="sales_presentation_item">
					<div class="info">
						<span>上月消耗</span>
						<span style="font-size:22px">{{last_month_consume}}</span>
					</div>
					</Col>
				</Row>
			</div>
		</div>
		<div style="margin-top: 10px;">
			<div class="multiple">
				<div class="child-div">时间区间</div>
				<RadioGroup v-model="timePeriod" @on-change="getList">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
						type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
				</RadioGroup>
			</div>
			<div class="multiple" v-if="userInfo.role_type == 1 || userInfo.role_type == 9">
				<div class="child-div">渠道</div>
				<Select v-model="shop_id" style="width: 200px;" @on-change="getList">
					<Option v-for="item in clientIdList" :value="item.id" :key="item.id">
						{{item.username }}-[{{item.id}}]
					</Option>
				</Select>
			</div>
			<div class="multiple">
				<div class="child-div">城市</div>
				<Select v-model="quotationAdvCity" style="width: 100px;" @on-change="getList">
					<Option v-for="item in cityList" :value="item.city" :key="item.city">
						{{ item.city}}
					</Option>
				</Select>
				<Button type="primary" @click="initSearch" style="margin-left: 10px;">重置</Button>
				<Button type="primary" @click="exportData" style="margin-left: 10px;">导出报表</Button>
			</div>
			<div style="width: 100% ;margin-top: 20px;">
				<Table :columns="columns" :data="datas" ref="table">
				</Table>
			</div>
			<div class="pager">
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small"
					show-elevator />
			</div>
		</div>
		<Modal v-model="balanceModal" width="500" title="余额">
			<BalanceList></BalanceList>
		</Modal>
		<Modal v-model="rechargeModal" width="1000" title="充值明细">
			<RechargeDetail :content_class="content_class"></RechargeDetail>
		</Modal>
		<Modal v-model="costModal" width="1000" title="消耗列表">
			<CostList :clientIdList="clientIdList" :cityList="cityList"></CostList>
		</Modal>
	</Card>
</template>
<script>
	import {
		getNewCostList,
		getBalanceData,
		getClientIdList
	} from "../../api/finance";
	import {
		getAdvCity,
	} from "../../api/runSet";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	import RechargeDetail from "./RechargeDetail.vue"
	import BalanceList from "./components/BalanceList.vue"; //排行榜
	import CostList from "./components/CostList.vue"; //排行榜
	export default {
		name: "CostReport",
		components: {
			BalanceList,
			RechargeDetail,
			CostList
		},

		data() {
			return {
				content_class: 'content1',
				name: '',
				timePeriod: '0',
				shop_id: [],
				timePeriodDate: [],
				statistics_way: '1',
				clientIdList: [],
				cityList: [],
				quotationAdvCity: '',
				balanceModal: false,
				rechargeModal: false,
				costModal: false,
				count: 0,
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 500],
				datas: [],
				salesPresentation: [{
						name: "账户余额",
						unit: "人"
					},
					{
						name: "本月充值",
						unit: "人"
					},
					{
						name: "本月消耗",
						unit: "人"
					},
					{
						name: "上月消耗",
						unit: "个"
					},
				],
				columns: [{
						"title": "渠道",
						"key": "channel_name",
						align: 'center'
					},
					{
						"title": "日期",
						"key": "date_time",
						align: 'center'
					},
					{
						"title": "城市",
						"key": "city",
						align: 'center'
					},
					{
						"title": "有效点击",
						"key": "form_nums",
						align: 'center'
					},
					{
						"title": "出价",
						"key": "quotation_average_money",
						align: 'center'
					},
					{
						"title": "消耗",
						"key": "quotation_money",
						align: 'center'
					},
					{
						"title": "该日充值金额",
						"key": "day_recharge_money",
						align: 'center'
					},
					{
						"title": "截止该日余额",
						"key": "balance",
						align: 'center'
					},
					{
						"title": "结算状态",
						"key": "settle_status_name",
						align: 'center'
					}, {
						"title": "当前余额",
						"key": "now_balance",
						align: 'center'
					},
				],
				balance: '***',
				recharge: '***',
				consume: '***',
				last_month_consume: '***',
				exportDatas: [],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.loadData();
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getBalanceData(that, data);
				that.balance = res.data.balance ? res.data.balance : 0;
				that.recharge = res.data.recharge ? res.data.recharge : 0;
				that.consume = res.data.consume ? res.data.consume : 0;
				that.last_month_consume = res.data.last_month_consume ? res.data.last_month_consume : 0;
				res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getClientIdList(that, data);
				that.clientIdList = res.data.list;
			},
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					page: that.page,
					pageSize: that.pageSize,
					quotationAdvCity: that.quotationAdvCity,
					timePeriod: that.timePeriod,
					timePeriodDate: that.timePeriodDate,
					shop_id: that.shop_id,
				};
				let res = await getNewCostList(that, data);
				if (res.code == 1) {
					that.datas = res.data.list;
					that.count = res.count;
				}
			},
			initSearch() {
				this.quotationAdvCity = '';
				this.page = 1;
				this.pageSize = 10;
				this.timePeriod = 0;
				this.timePeriodDate = [];
				this.shop_id = '';
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			showBalance() {
				let that = this;
				that.balanceModal = true;
			},
			showRecharge() {
				let that = this;
				that.rechargeModal = true;
			},
			showCostList() {
				let that = this;
				that.costModal = true;
			},
			async exportData() {
				let that = this;
				let data = {
					token: that.token,
					page: that.page,
					pageSize: 1000,
					quotationAdvCity: that.quotationAdvCity,
					timePeriod: that.timePeriod,
					timePeriodDate: that.timePeriodDate,
					shop_id: that.shop_id,
				};
				let res = await getNewCostList(that, data);

				if (res.code == 1) {
					that.exportDatas = res.data.list;
				}
				var myDate = new Date()
				this.$refs.table.exportCsv({
					filename: "消耗表" + myDate.toLocaleDateString(), //导出Excel的名字
					original: false,
					columns: this.columns, //table的每一列
					// orderid是订单编号，此处进行转换，因为orderid过长，不转换会变成科学计数法的格式
					data: that.exportDatas.map(k => {
						k.orderid = "\t" + k.orderid;
						return k;
					})
				});
			},
		},


	}
</script>
<style scoped lang="less">
	.yellow_btn {
		color: #F8BD66;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}


	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.sales_presentation {
		width: 100%;
		padding-bottom: 5px;

		&_item {
			&>div {
				cursor: pointer;
				position: relative;
				width: 100%;
				box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
				border-radius: 3px;
				padding: 5px 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				span:nth-child(2) {
					margin: 10px 0;
				}
			}

			.info {
				&>div {
					width: 40%;
					height: 70px;
					// background: #277dd3;
					position: absolute;
					right: 20px;
					bottom: 50%;
					transform: translateY(50%);
				}
			}
		}
	}

	.container {
		border-radius: 5px;
		margin-top: 20px;
		border: 1px solid #ccc;
		width: 100%;
		padding: 0 10px;
		border-top: 5px solid #277dd3;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
